<template>
  <el-container class="login-body">
    <el-container class="info-section el-col-12">
      <div class="panel">
        <h1>The Future of<br>Stock Surveillance</h1>
        <div>Sequire unlocks stock buyers' behaviors and trends for
          issuers of publicly traded companies</div>
        <div class="learn-more">
          <el-button type="text" v-track="{ event: 'login_learn' }">
            <a href="https://mysequire.com/" target="_blank">LEARN MORE</a>
          </el-button>
        </div>
      </div>
      <el-footer class="powered-by">Powered by SRAX.</el-footer>
    </el-container>
    <div class="form-section el-col-12">
      <div class="panel">
        <div class="content-img">
          <img :src="getLogo" alt=""/>
        </div>
        <div class="password-sent" v-if="newPasswordSet">
          <i class="icon-checkmark color-primary font-size-40"/>
          <div class="black-title">Password set up successfully</div>
          <div class="subtitle">
            Your new password was set up successfully.
            You will be redirected to the log in screen automatically
            or click the "Go back to Login" link below.
          </div>
          <router-link
            class="no-underline"
            to="/"
            v-track="{ event: 'password_reset_back' }"
          >
            Go back to Login
          </router-link>
        </div>
        <div v-else>
          <div class="blue-title">Set up your new password</div>
          <div class="subtitle">Please insert your new password to log into your account.</div>
          <div class="blue-bit"/>
          <el-form
            class="login-form"
            :model="newPasswordForm"
            ref="newPasswordForm"
            :disabled="isLoading"
            :rules="rules"
            @submit.native.prevent
            @keyup.enter.native="submitForm"
            size="medium"
          >
            <el-form-item label="Password" prop="password">
              <el-input
                v-model="newPasswordForm.password"
                show-password
                vid="password"
              />
            </el-form-item>
            <el-form-item label="Confirm password" prop="confirmPassword">
              <el-input v-model="newPasswordForm.confirmPassword" show-password/>
            </el-form-item>
            <el-form-item class="submit-button">
              <el-button
                type="primary"
                @click="submitForm"
                class="btn-block"
                :disabled="isLoading"
                size="medium"
                v-track="{ event: 'new_password_send' }"
              >
                Log in
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import Vue from 'vue';
import { Notification } from 'element-ui';
import { mapState } from 'vuex';
import { getBrand } from '@/whitelabel.config';
import IAM_API from '@/store/iamService';

export default {
  name: 'NewPassword',
  data() {
    return {
      isLoading: false,
      newPasswordSet: false,
      brand: getBrand(),
      newPasswordForm: {
        password: '',
        confirmPassword: '',
      },
      rules: {
        password: {
          required: true,
          regex: '^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()\\-_~=+\\[\\]{};:.?,\\\\])^[A-Za-z\\d!@#$%^&*()\\-_~=+\\[\\]{};:.?,\\\\\\\\]{8,30}$',
        },
        confirmPassword: { password: '@password' },
      },
    };
  },
  computed: {
    ...mapState({
      isDark: (state) => state.layout.isDark,
    }),
    getLogo() {
      if (this.isDark && Object.prototype.hasOwnProperty.call(this.brand.logoList, 'loginDark')) return this.brand.logoList.loginDark;
      return this.brand.logoList.login;
    },
  },
  methods: {
    submitForm() {
      this.$refs.newPasswordForm.validate((valid) => {
        if (valid) this.passwordSubmit();
        else {
          Notification({
            type: 'error',
            title: 'Error!',
            message: 'Please make sure the password match.',
          });
        }
      });
    },
    passwordSubmit() {
      this.isLoading = true;
      const emailCode = this.$route.query.email_code;
      const recoveryCode = this.$route.query.recovery_code;

      if (emailCode && recoveryCode) {
        const passwordRecovery = {
          email_code: emailCode,
          recovery_code: recoveryCode,
          password: this.newPasswordForm.password,
        };

        IAM_API({
          method: 'post',
          url: '/passwordRecovery/new',
          data: { password_recovery: passwordRecovery },
        }).then(() => {
          this.newPasswordSet = true;
          this.isLoading = false;
        }).catch((e) => {
          this.isLoading = false;
          Vue.config.errorHandler(e);
        });
      }
    },
  },
  beforeMount() {
    const html = document.getElementById('html-base');

    if (this.$store.state.layout.isDark) html.classList.add('dark');
    else html.classList.remove('dark');
  },
};
</script>

<style scoped lang="scss">
  @import "~@/styles/login.scss";
</style>
